import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "@src/reducers/store";

import { FilterModal } from "@components/organisms/modals/filter-modal/filter-modal";
import { useNewInitialFilterModalHook } from "@src/components/organisms/modals/filter-modal/use-new-initial-filter-modal-hook";
import styles from "./initial-structure-filter.module.scss";

const cssClassName = "initial-structure-filter-modal-layer";

export const InitialStructureFilter = () => {
  const showFilterModal = useSelector(
    (state: RootState) => state.yourSlice.initialFilterModal.showFilterModal,
  );

  return (
    <>
      {showFilterModal && (
        <div className={styles[cssClassName]}>
          <FilterModal useHook={useNewInitialFilterModalHook} />
        </div>
      )}
    </>
  );
};
